import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
  Snackbar,
  Stack
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import Header from "../components/header";
import Footer from "../components/footer";
import getApiBase from "../components/getApiBase";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [feedback, setFeedback] = useState({ open: false, success: true });
  const [loading, setLoading] = useState(false);

  const validatePassword = () => {
    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      setFeedback({ open: true, success: false });
      return false;
    }

    if (password.length < 8) {
      setMessage("Password must be at least 8 characters.");
      setFeedback({ open: true, success: false });
      return false;
    }

    return true;
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (!validatePassword()) return;

    setLoading(true);
    try {
      const res = await axios.post(`${getApiBase()}/api/auth/reset-password`, {
        token,
        newPassword: password,
      });

      setMessage(res.data.message || "Password reset successful.");
      setFeedback({ open: true, success: true });

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      const errMsg = err.response?.data?.message || "Reset failed.";
      setMessage(errMsg);
      setFeedback({ open: true, success: false });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
      <Header />
      <Container
        maxWidth="sm"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "80vh" }}
      >
        <motion.div initial={{ opacity: 0, y: -30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <Typography variant="h4" gutterBottom>Reset Your Password</Typography>
          <form onSubmit={handleReset}>
            <Stack spacing={3}>
              <TextField
                type="password"
                label="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                fullWidth
              />
              <TextField
                type="password"
                label="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                fullWidth
              />
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={loading}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </Button>
            </Stack>
          </form>
        </motion.div>
        <Snackbar open={feedback.open} autoHideDuration={6000} onClose={() => setFeedback({ ...feedback, open: false })}>
          <Alert severity={feedback.success ? "success" : "error"} onClose={() => setFeedback({ ...feedback, open: false })}>
            {message}
          </Alert>
        </Snackbar>
      </Container>
      <Footer />
    </Box>
  );
};

export default ResetPassword;
